import { database } from "../firebase";
import { ref, set, get, onValue, off, serverTimestamp } from "firebase/database";

/**
 * Fetches existing scan data once.
 */
export async function fetchScanData(userPath, scanID) {
  const scanRef = ref(database, `data/scans/${userPath}/${scanID}`);
  const snapshot = await get(scanRef);
  return snapshot.val();
}

/**
 * Writes a temporary scan record to Firebase and subscribes to
 * its status. Resolves when the backend sets redundant / redundantLoc.
 *
 * @returns {{ promise: Promise<{redundant, redundantLoc, scanID, userPath}>, cleanup: function }}
 */
export function saveTempScan(userPath, scanID, decodedText, latitude, longitude, accuracy) {
  const tempRef = ref(database, `data/temp/${userPath}/${scanID}`);
  const statusRef = ref(database, `data/temp/${userPath}/${scanID}`);

  let cleanup = () => {};

  const promise = (async () => {
    await set(tempRef, {
      qrcodeData: decodedText,
      coordinates: { x: latitude, y: longitude, acc: accuracy },
      createTimestamp: serverTimestamp(),
      tempData: false,
    });

    return new Promise((resolve) => {
      const listener = onValue(statusRef, (snap) => {
        const val = snap.val();
        if (!val) return;

        const { redundant, redundantLoc } = val;
        if (redundant === undefined || redundantLoc === undefined) return;

        off(statusRef, "value", listener);
        resolve({ redundant, redundantLoc, scanID, userPath });
      });

      cleanup = () => off(statusRef, "value", listener);
    });
  })();

  return { promise, cleanup: () => cleanup() };
}
